
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import '@emotion/css';
import 'vue';
import { m as mode } from './color-mode-observer-de5da461.js';
import CBox from './CBox.js';
import { a as SNA } from './props.types-cbb7b1ff.js';

/**
 * Hey! Welcome to @chakra-ui/vue SkipNavLink
 *
 * Renders a link that remains hidden until focused to skip to the main content.
 *
 * @see Docs     https://vue.chakra-ui.com/skip-nav-link
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CSkipNav/CSkipNav.js
 */
var FALLBACK_ID = 'chakra-skip-nav';

var createSkipNavLinkStyles = function createSkipNavLinkStyles(props) {
  var baseStyles = {
    userSelect: 'none',
    border: '0',
    borderRadius: 'md',
    fontWeight: 'semibold',
    height: '1px',
    width: '1px',
    margin: '-1px',
    padding: '0',
    outline: '0',
    overflow: 'hidden',
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    _focus: {
      clip: 'auto',
      width: 'auto',
      height: 'auto',
      boxShadow: 'outline',
      padding: '1rem',
      position: 'fixed',
      top: '1.5rem',
      insetStart: '1.5rem',
      bg: mode('white', 'gray.700')
    }
  };
  return Object.assign({}, baseStyles);
};
/**
 * CSkipNavLink component
 *
 * Renders a link that remains hidden until focused to skip to the main content.
 *
 * @see Docs https://vue.chakra-ui.com/skip-nav
 */


var CSkipNavLink = {
  name: 'CSkipNavLink',
  mixins: [createStyledAttrsMixin('CSkipNavLink')],
  props: {
    id: {
      type: String,
      default: FALLBACK_ID
    }
  },
  computed: {
    colorMode: function colorMode() {
      return this.$chakraColorMode();
    },
    theme: function theme() {
      return this.$chakraTheme();
    },
    componentStyles: function componentStyles() {
      return createSkipNavLinkStyles();
    }
  },
  render: function render(h) {
    return h('a', {
      class: this.className,
      attrs: {
        href: "#" + this.id
      }
    }, this.$slots.default);
  }
};
/**
 * CSkipNavLink component
 *
 * Renders a div as the target for the link.
 *
 * @see Docs https://vue.chakra-ui.com/skip-nav
 */

var CSkipNavContent = {
  name: 'CSkipNavContent',
  mixins: [createStyledAttrsMixin('CSkipNavContent')],
  props: {
    id: {
      type: String,
      default: FALLBACK_ID
    },
    to: SNA
  },
  render: function render(h) {
    return h(CBox, {
      class: this.className,
      attrs: {
        id: this.id,
        tabIndex: '-1',
        style: {
          outline: 0
        },
        'data-testid': 'chakra-skip-nav'
      }
    }, this.$slots.default);
  }
};

export { CSkipNavContent, CSkipNavLink };
